import { on } from 'delegated-events'
import { setupForm } from '@components/styled-form'

const reInitForm = () => {
  const form = document.querySelector('.ebook-form')

  if (form) {
    setupForm(form)
  }
}

const setupEbookCheck = () => {

    const form = document.querySelector('.ebook-form')

    if (form) {

        const checkboxes = form.querySelectorAll('input[type="checkbox"]');

        var checkboxArray = Array.from(checkboxes);

        const ebookblocks = document.querySelectorAll('.ebook-block');
        ebookblocks.forEach(function(ebook) {
            ebook.addEventListener('click', function() {
                var blockid = ebook.getAttribute('data-blockid');
                document.querySelector('#checkbox-' + blockid).click();
            });
        });

        checkboxArray.forEach(function(checkbox) {
            checkbox.addEventListener('change', confirmCheck);
        });

    }

}

const confirmCheck = () => {

    const form = document.querySelector('.ebook-form')

    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    var checkboxArray = Array.from(checkboxes);

    const auds = [];
    if (Array.prototype.slice.call(checkboxes).some(x => x.checked)) {
      checkboxArray.forEach(function(checkbox) {
        if (checkbox.checked) {
          auds.push(checkbox.getAttribute('data-audience'));
        }
      });
    }

    var audiences = auds.filter(function (audience, index) {
      return auds.indexOf(audience) === index;
    });

    const crossAud = form.querySelector('.cross-audience');
    const crossAudField = crossAud.querySelector('textarea.cross-audience-field');

    if(audiences.length > 1) {
      if (crossAud.classList.contains('hidden')) {
        crossAud.classList.remove('hidden');
        crossAudField.setAttribute('required', 'required')
      }
    }
    else {
      crossAud.classList.add('hidden');
      crossAudField.removeAttribute('required')
    }

}

setupEbookCheck()

on('pagecontent:replace', 'html', reInitForm)
